import { render, staticRenderFns } from "./Workouts.vue?vue&type=template&id=55a1b644&scoped=true"
import script from "./Workouts.vue?vue&type=script&lang=js"
export * from "./Workouts.vue?vue&type=script&lang=js"
import style0 from "./Workouts.vue?vue&type=style&index=0&id=55a1b644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a1b644",
  null
  
)

export default component.exports